import { Form as _Form } from '@hrlogics/react-components/form';

/** @deprecated use `Form` component from `@hrlogics/react-components/form` package */
export const Form = _Form;
